<template>
<div>
  <customList :filterItems="formItems" :filterModel="filter"  @selectChange="selectChange" :columns="columns" :listUrl="'/admin/prompt/list'"></customList>
  <Modal
      title="Prompt信息"
      v-model="settleModalstatus"
      :mask-closable="false"
      :width="500"
      @on-cancel="closeSettleModal"
    >
      <div>
        <CustomForm mode='detail' :title="''" :dataArr="createObjArr" :model="createObj" :defaultSpan="24" :labelWidth="100"/>
      </div>
      <div slot="footer">
        <Button @click="closeSettleModal">关闭</Button>
      </div>
    </Modal>
</div>
</template>
<script>
import { getDataFromConfig } from '../../../assets/js/share';
const createObjArr = [
  {
    label: '用户',
    key: 'userName'
  },
  {
    label: '提问',
    key: 'message'
  },
  {
    label: '回答',
    key: 'reply'
  }
];
// SELECT COUNT(*) AS count FROM user WHERE name LIKE '%商%'
// SELECT COUNT(id) AS count FROM prompt_log WHERE 1=1 AND user_name LIKE `%商%`
const createObj = getDataFromConfig(createObjArr); // 通过getDataFromConfig方法推导出模型对象
export default {
  name: 'promptList',
  data () {
    return {
      settleModalstatus: false,
      createObjArr,
      createObj,
      formItems: [
        { label: '提问词', model: 'message' },
        { label: '用户', model: 'userName' },
        { type: 'select', label: '返回状态', model: 'resStatus', options: [{ name: '全部', value: '' }, { name: '成功', value: 0 }, { name: '请求中', value: -1 }, { name: '敏感话题', value: 1027 }], fun: 'selectChange' },
        { type: 'select', label: '使用平台', model: 'apiType', options: [{ name: '全部', value: '' }, { name: 'minimax', value: 1 }, { name: 'OpenAI', value: 2 }], fun: 'selectChange' },
        { type: 'button', buttonArr: [{ message: '查询', type: 'primary', fun: 'selectChange' }] }
      ],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '提问词', key: 'message', width: 230, ellipsis: true, tooltip: true, fixed: 'left' },
        { title: '返回信息', key: 'reply', width: 230, ellipsis: true, tooltip: true },
        {
          title: '返回状态',
          key: 'res_status',
          width: 70,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.res_status == 0 ? '成功' : params.row.res_status == -1 ? '请求中' : params.row.res_status == 1027 ? '敏感话题' : '')
            ]);
          }
        },
        { title: '用户', key: 'user_name', width: 70, ellipsis: true, tooltip: true },
        { title: '创建时间',
          key: 'create_time',
          width: 150,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.create_time);
            return h('div', [
              h('span', {}, params.row.create_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        { title: '响应时间',
          key: 'update_time',
          width: 150,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.update_time);
            return h('div', [
              h('span', {}, params.row.update_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        { title: '返回json', key: 'res_json', minWidth: 250, ellipsis: true, tooltip: true },
        { title: '请求json', key: 'message_json', minWidth: 250, ellipsis: true, tooltip: true },
        { title: '操作',
          key: 'groupName',
          width: 110,
          fixed: 'right',
          render: (h, params) => {
            const buttonArr = [];
            buttonArr.push(
              h(
                'Button',
                {
                  props: { type: 'info', size: 'small' },
                  on: {
                    click: () => {
                      const obj = {
                        message: params.row.message,
                        userName: params.row.user_name,
                        reply: params.row.reply,
                        apiType: params.row.api_type
                      };
                      this.createObj = Object.assign({}, obj);
                      this.settleModalstatus = true;
                    }
                  }
                },
                '查看'
              )
            );
            return h('div', { }, buttonArr);
          }
        }
      ]
    };
  },
  methods: {
    selectChange () {
      alert('开始查找');
    },
    closeSettleModal () {
      this.settleModalstatus = false;
    }
  },
  mounted () {
    this.columns.forEach((item) => {
      this.$set(item, 'align', 'center');
    });
  }
};
</script>
<style scoped>
</style>
